// extracted by mini-css-extract-plugin
module.exports = {"StickyColumn":"layout_StickyColumn__1tn6f"};